import {XauditModel} from '../xaudit.model';
import {DataARPaymentModel} from './data-ar-payment.model';

export class DataARPaymentDistribsModel extends XauditModel{
  PaymetnDistributionID: string;
  PaymetnID: string;
  LedgerID: string;
  Amount: number;
  enumCurrencyID: string;

  dataARPayment: DataARPaymentModel;
}
